import { openChatPanelOnNextVisit, requestChatPanelOpen } from '@/modules/chat'

export const askAboutCase = (slug: string) => {
  openChatPanelOnNextVisit(slug)
  requestChatPanelOpen()
}
